import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PersonIcon from '@mui/icons-material/Person';
import CustomDataGrid from '../../../../components/ui/customDataGrid/customDataGrid.component';
import { USERS_URL } from '../../../../api/users';
import styles from './tenantUsersList.module.css';
import { useHasPermission } from '../../../../contexts/auth';

export const TenantUsersList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canViewUsers = useHasPermission("users.view_user");

  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: 'ID',
    },
    {
      field: 'first_name',
      headerName: t('First Name'),
    },
    {
      field: 'last_name',
      headerName: t('Last Name'),
    },
    {
      field: 'email',
      headerName: t('Email'),
    },
    {
      field: 'is_active',
      headerName: t('Active'),
      type: 'boolean',
    },
    {
      field: 'group_names',
      headerName: t('Permission Groups'),
    },
  ];

  const handleRowClick = (id: string) => {
    navigate(`/tenant/users/${id}`);
  };

  if (!canViewUsers) {
    return null;
  }

  return (
    <Box className={styles.container}>
      <CustomDataGrid
        icon={<PersonIcon />}
        title={t('Users')}
        url={USERS_URL}
        gridSettingsKey="TENANT_USERS"
        columns={columns}
        refreshEventName="tenantUpdated"
        onRowClick={handleRowClick}
      />
    </Box>
  );
};
